const imgContinents = {
  'North America':
    'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/968afb90-ac92-44de-a6d9-bbd220b7fa64/dbjftku-ea7e50b6-880b-4384-bac8-f2887927100d.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzk2OGFmYjkwLWFjOTItNDRkZS1hNmQ5LWJiZDIyMGI3ZmE2NFwvZGJqZnRrdS1lYTdlNTBiNi04ODBiLTQzODQtYmFjOC1mMjg4NzkyNzEwMGQucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.hAbGE-0_k5QYHIfGcG9IyNbYcXd5gx1uXGnj-FFIJHU',
  Asia: 'https://www.wecinternational.org/admin/resources/asia-home.png',
  'South America':
    'https://www.orchidproject.org/wp-content/uploads/2019/03/saoutl.png',
  Europe:
    'https://www.pngkit.com/png/full/390-3903931_created-with-raphal-europe-map-white-png.png',
  Africa:
    'https://www.pngplay.com/wp-content/uploads/6/Africa-White-Map-Transparent-Background.png',
  'Australia-Oceania':
    'https://www.pngkit.com/png/full/76-765568_bp-oil-spill-in-great-australian-bight-would.png',
};

export default imgContinents;
